const QueryString = (function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    const query_string = {};
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        // If first entry with this name
        if (typeof query_string[pair[0]] === 'undefined') {
            query_string[pair[0]] = pair[1];
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === 'string') {
            const arr = [query_string[pair[0]], pair[1]];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(pair[1]);
        }
    }
    return query_string;
})();

(function ($) {
    $.fn.listArticle = function (settings) {
        let listIt = 0;
        let notMakeActive = 0;
        var options = {
                paging: 0,
                pagingBy: 5,
                fadeIn: 500,
                fadeOut: 100,
                magazine: 'blesk',
                forcepaging: 0,
                showRecentArticles: true,
            },
            settings = settings,
            $that = $(this),
            chapterIds = [];
        // Výsledná pozice kapitoly po vyhodnocení URL (viz níže).
        // QueryString se čte jen jednou při načtení skriptu, takže po replaceState
        // už z něj nejde vycházet - controlPagingElements() proto bere tuhle hodnotu.
        let resolvedPosition = 0;
        options = $.extend(options, settings);

        if (options.paging == 1) {
            var paging = {
                // aktivní skupina paging odkazů
                firstVisibleAnchorIndexOfChapters: null,
                lastVisibleAnchorIndexOfChapters: null,
                inProgress: 0,
                style: null,
            };
            $('ul.main li').siblings('strong').remove();
        }

        if (typeof $.cookie('newuser') !== 'undefined') {
            if (options.magazine == 'blesk') {
                $.cookie('newuser', 1);
                listIt = 1;
            } else {
                /* PŮVODNÍ PODMÍNKA LISTOVÁNÍ
            *
            if (($.cookie('newuser') == 1) || options.forcepaging == 1){
                 if (options.magazine == "blesk") {

                    listIt = 0;
                 }
                 else if (options.magazine == "bpz") {
                    listIt = 0;

                 }
            } */
                listIt = 1;
            }
        } else {
            if (options.magazine == 'blesk') {
                $.cookie('newuser', 1);
            }
            listIt = 1;
        }

        if (listIt == 1) {
            if (options.magazine != 'bpz') {
                $that.find('.inner_7').removeClass('inner_7').addClass('inner_8');
                // sirka clanku
                let gridWidth,
                    // padding jednotlivých li
                    padding;
                // if(options.magazine == "isport") gridWidth = $that.find("[class^='grid_8']").width();
                // else if(options.magazine == "blesk") gridWidth = $that.find("#article").width();
                // else gridWidth = $that.find("[class^='inner_']").width()
                gridWidth = $that.find('#article').width() - 20;
                switch (options.paging) {
                    case 0:
                        padding = 0;
                        break;
                    default:
                        padding = 10;
                }
            }

            // načtení hashe
            hash = getHash();
            // načtení parametru kapitola z URL
            // Parametr nese pořadové číslo kapitoly (0 = úvod), stejně jako na mobilu
            section = getSection();
            const activePosition = resolveChapterPosition(section);

            if (options.magazine === 'bpz') $that.removeClass('notlisted').addClass('listed');
            $that.find('.notlisted').removeClass('notlisted').addClass('listed');
            $that
                .find('ul.main')
                .addClass('listed')
                .css('display', 'block')
                .children('li')
                .each(function (i) {
                    if (options.paging == 0) {
                        if (i == 0) {
                            if (options.magazine == 'blesk') {
                                $(this).find('h1, .leadsection').css('margin-left', '80px');
                            }
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    } else {
                        if (i == 0) {
                            $(this).attr('data-id', 'intro');
                            chapterIds.push($(this).data('id'));
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    }

                    // Aktivní kapitola se určuje podle pořadového čísla z URL,
                    // ne podle shody data-id (index v chapterIds == pořadové číslo,
                    // protože na indexu 0 je vždy "intro")
                    if (i === activePosition) {
                        $(this).addClass('active');
                    }

                    if (options.magazine == 'blesk') {
                        $(this).removeClass('pseudoInner_7');
                        if ($(this).attr('id') !== 'related') {
                            $(this)
                                .css('width', '610px')
                                .css('margin', '0 auto')
                                .css('float', 'none');
                        }
                    } else {
                        $(this).css('padding', 0).css('padding-bottom', '10px');
                    }
                });

            // Zpětná kompatibilita se starými URL, které nesly ID kapitoly.
            // Hodnotu nejdřív zkusíme jako pořadové číslo, pak jako ID kapitoly
            // (sem spadá i "related"); výsledek promítneme do aktivní kapitoly
            // a URL přepíšeme na kanonickou podobu (bez skoku v historii).
            if (section) {
                const requested = String(section).replace('#', '');
                let canonicalPosition = -1;

                // 1) pořadové číslo - platí jen když na té pozici kapitola existuje
                if (activePosition >= 0 && activePosition <= chapterIds.length - 1) {
                    canonicalPosition = activePosition;
                }

                // 2) ID kapitoly ze staré URL, případně "related"
                // ($(...).data('id') vrací u číselných ID number, proto String())
                if (canonicalPosition === -1) {
                    for (let idx = 0; idx < chapterIds.length; idx++) {
                        if (String(chapterIds[idx]) === requested) {
                            canonicalPosition = idx;
                            break;
                        }
                    }
                }

                // 3) neznámá hodnota - úvod
                if (canonicalPosition === -1) {
                    canonicalPosition = 0;
                }

                if (canonicalPosition !== activePosition) {
                    $that.find('ul.main > li.active').removeClass('active');
                    $that.find('ul.main > li').eq(canonicalPosition).addClass('active');
                }

                resolvedPosition = canonicalPosition;

                // úvod je kanonicky bez parametru, ostatní s pořadovým číslem
                // (kapitola "více" s hodnotou "related" - viz chapterParam())
                if (canonicalPosition === 0 || chapterParam(canonicalPosition) !== requested) {
                    history.replaceState(null, document.title, chapterUrl(canonicalPosition));
                }
            }

            // Pojistka - kdyby se aktivní kapitolu nepodařilo určit, zůstaneme na úvodu
            if (!$that.find('ul.main > li.active').length) {
                $that.find('ul.main > li').first().addClass('active');
            }

            if (settings.paging === 0) {
                controlsButtons = $that.find('.listingControlButtons');
                smallControlButtons = controlsButtons.clone();
                smallControlButtons
                    .addClass('smallControlButtons')
                    .css('display', 'block')
                    .find('.counter')
                    .remove();
                if (options.magazine == 'bpz') {
                    $that.find('ul.listed > li').each(function () {
                        $(this)
                            .find('.artSectionTop')
                            .prepend(
                                smallControlButtons
                                    .removeClass('artSectionBottom')
                                    .addClass('sectionPaging')
                                    .clone(),
                            );
                    });
                } else if (options.magazine == 'blesk') {
                    // PUVODNI_BLESK_VERZE-$that.find(".bottom .clearfix").before(smallControlButtons);
                } else {
                    $that.find('ul.listed').append(smallControlButtons);
                }
            } else {
                $that.find('ul.listed').before("<div class='paging' style='min-width:100%'/>");
                $that.find('ul.listed').after("<div class='paging' style='min-width:100%'/>");

                $that
                    .find('.paging')
                    .append(
                        "<a class='prev showPrev'><div class='pagingPrevArrow'></div>Předchozí</a>" +
                            "<div class='pagingHolder'></div>" +
                            "<a class='next showNext'>Další<div class='pagingNextArrow'></div></a>",
                    );
                $that.find('.paging').after("<div class='clearfix' />");
                $that.find('.paging').append("<div class='clearfix' />");
                const pagingPosition = $that.find('.paging .pagingHolder');

                for (var i = 0; i <= chapterIds.length - 1; i++) {
                    if (i == 0) {
                        name = 'úvod';
                        id = chapterIds[i];
                    } else if (i == chapterIds.length - 1) {
                        if (
                            $that.find(`ul.listed > li:nth-child(${i + 1})`).data('id') == 'related'
                        ) {
                            name = 'více';
                        } else {
                            name = i;
                        }
                        id = chapterIds[i];
                    } else {
                        name = i;
                        id = chapterIds[i];
                    }

                    if (String(id).includes('disabled')) {
                        pagingPosition.append(
                            `<a href="#" class="disabled" aria-disabled="true">${name}</a>`,
                        );
                    } else {
                        // Href nese pořadové číslo kapitoly, data-pos slouží
                        // pro dohledání odkazu podle pozice. data-id zůstává,
                        // protože podle něj se dohledává <li> a pracuje s ním
                        // applyPagingStyle() i switchPaging().
                        pagingPosition.append(
                            `<a href="${chapterUrl(i)}" data-id="${id}" data-pos="${i}" data-parts="${
                                chapterIds.length
                            }">${name}</a>`,
                        );
                    }
                }

                if (settings.paging === 1) controlPagingElements();

                // zamknutí buttonů v případě placeného článku-zjištování přes login box
                /* if($(".login-box").length){
                           $("button.prev").replaceWith("<div class='prev'><div class='pagingPrevArrow'></div>Předchozí</div>");
                           $("button.next").replaceWith("<div class='next'>Další<div class='pagingNextArrow'></div></div>");
                           $(".pagingHolder").replaceWith("<div class='pagingHolder'><span data-id='intro' class='active'>Úvod</span><span data-id='related'>Více</span></div>");
                           $("<div class='block-bg-buttons'></div>").appendTo(".paging");
                } */
            }

            const authors = $that.find('.authors');
            $(document).ready(() => {
                const socialShares = $that.find('.socialShares').clone();
                $that.find('.socialShares').hide();

                if (options.magazine == 'blesk') {
                    /* PUVODNI_BLESK_VERZE-$that.find("ul.listed li:first-child .articleDetails").append(socialShares);
                    $that.find("ul.listed li:first-child .articleDetails .socialShares").css("margin-left", "80px");
                    socialShares.css("margin-left", 0);
                    $that.find(".bottom .clearfix").before(socialShares);
                    if ($that.find("ul.listed li:first-child[class='active']").length == 1) {
                        $that.find(".bottom .socialShares").hide();
                        $that.find(".articleDetails .socialShares").show();
                    } */
                    $that.find('.articleDetails .socialShares').show();
                }
                if (options.magazine == 'isport' || options.magazine == 'blesk') {
                    $that.find('ul.main >li').each(function () {
                        $(this).append("<div class='social' />");
                    });
                    if (options.magazine == 'isport') {
                        const authors = $that
                            .find('.authors')
                            .css('float', 'margin-right')
                            .removeClass('underArticle')
                            .removeClass('mt0px')
                            .clone();
                        $that.find('.authors').hide();
                        $that
                            .find('.social')
                            .append(socialShares.css('float', 'left'))
                            .append(authors.removeClass('authors').css('text-align', 'center'));
                    } else {
                        // $that.find(".social").append(authors.removeClass("authors").css("text-align", "left"));
                        $that
                            .find('.imgInArt')
                            .append(socialShares.css('float', 'left').css('clear', 'both'));
                        $that.find('.articleDetails .socialShares').show();
                    }
                    $that.find('.socialMedia').hide();
                    $that.find('.bottom .socialShares > *').hide();
                }
            });
            if (options.magazine == 'blesk') {
                /* PUVODNI_BLESK_VERZE-var related = $that.find("ul.listed li#related").length;
                $that.find(".socialMedia").hide();
                $that.find(".bottom .authors:not(.autorLeft)").css("margin-left", "80px");
                $that.find(".leadsection p").css("font-weight", "normal");
                if(related === 1) $that.find(".listingControlButtons .totalNumber").html(chapterIds.length-1);
                else $that.find(".listingControlButtons .totalNumber").html(chapterIds.length);
                $that.find(".listingControlButtons").css("display", "block"); */
                // $that.find("ul.main").addClass("inner_8");
            }
            if (options.magazine == 'bpz') {
                $that.find('.listingControlButtons').show();
                $that.find('.listingControlButtons .counter').addClass('numbers');
                $that.find('.listingControlButtons .totalNumber').html(chapterIds.length);
                $('#content .articleContent .articlePerex p').css('font-weight', 'normal');
                $('ul.listed > li').css('font-size', '17px').css('line-height', '22px');
            }

            buttonsControl($that.find('ul.listed > li.active'));

            // FIX: selektor teď zahrnuje i <a> (prev/next/moreArticles už nejsou jen button),
            // aby na ně šlo kliknout přes JS navigaci; disabled prvky (aria-disabled) klik ignorují,
            // a u <a> se navíc musí zavolat preventDefault, jinak prohlížeč reálně naviguje na href.
            $that
                .find(
                    '.listingControlButtons button, .listingControlButtons a, .paging a.prev, .paging a.next',
                )
                .click(function (e) {
                    if ($(this).attr('aria-disabled') === 'true') {
                        e.preventDefault();
                        return;
                    }
                    if ($(this).is('a')) {
                        e.preventDefault();
                    }
                    buttonPressed($(this));
                });
            $that.find('.paging a[data-id]').click(function (e) {
                e.preventDefault();
                paging.oldItem = $that.find('ul.listed > li.active');
                paging.newItem = $that.find(`ul.listed li[data-id="${$(this).data('id')}"]`);
                $that.find('.paging a.active').each(function () {
                    $(this).removeClass('active');
                });

                hideAndShowNext(paging.oldItem, paging.newItem);
            });
        }
        // getter for hash
        function getHash() {
            return window.location.hash;
        }
        function getSection() {
            return QueryString.kapitola;
        }

        // Pořadové číslo kapitoly z URL parametru (0 = úvod).
        // Vrací -1 pro nečíselnou hodnotu (např. "related") - ta se dohledá až
        // proti chapterIds v bloku zpětné kompatibility výše.
        // Záměrně nepracuje s chapterIds - volá se ještě před jejich naplněním.
        function resolveChapterPosition(value) {
            if (!value) return 0;
            const raw = String(value).replace('#', '');
            if (!/^\d+$/.test(raw)) return -1;
            return parseInt(raw, 10);
        }

        // Hodnota parametru kapitola pro danou pozici.
        // Kapitola se souvisejícími články ("více") má v URL "related", ne číslo.
        function chapterParam(position) {
            return chapterIds[position] === 'related' ? 'related' : String(position);
        }

        // URL kapitoly podle pořadového čísla, úvod (0) je bez parametru.
        function chapterUrl(position) {
            const baseUrl = window.location.origin + window.location.pathname;
            return position > 0 ? `${baseUrl}?kapitola=${chapterParam(position)}` : baseUrl;
        }

        // keypress navigation
        $('body').keydown((e) => {
            e.stopImmediatePropagation();
            if (e.keyCode == 37) {
                // left
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (options.paging == 0) {
                    if (chapterIds.indexOf(activeId) >= 0)
                        buttonPressed($that.find('.listingControlButtons .prev'));
                } else if (chapterIds.indexOf(activeId) > 0)
                    buttonPressed($that.find('.listingControlButtons .prev'));
            } else if (e.keyCode == 39) {
                // right
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (chapterIds.indexOf(activeId) + 1 < chapterIds.length)
                    buttonPressed($that.find('.listingControlButtons .next'));
            }
        });
        function buttonPressed(button) {
            let cls = button.attr('class'),
                oldItem = $that.find('ul > li.active'),
                dir,
                newItem;

            if (cls.search('showStart') != -1) dir = 'showStart';
            else if (cls.search('showNext') != -1) dir = 'next';
            else if (cls.search('showPrev') != -1) dir = 'prev';
            else dir = 'error';
            switch (dir) {
                case 'next':
                    // nextAll/prevAll: mezi kapitolami mohou být cizí elementy
                    newItem = oldItem.nextAll('li').first();
                    break;
                case 'prev':
                    newItem = oldItem.prevAll('li').first();
                    break;
                case 'showStart':
                    newItem = $that.find('ul > li:first-child');

                    break;
                case 'error':
                    newItem = 'error';
                    break;
            }
            hideAndShowNext(oldItem, newItem);
        }
        buttonsControl($that.find('#article ul.main > li.active'));

        // Zastaví všechna videa v daném elementu
        function pauseVideosInItem(item) {
            // HTML5 <video>
            item.find('video').each(function () {
                this.pause();
            });
            // YouTube / Vimeo iframy
            item.find('iframe').each(function () {
                const src = $(this).attr('src');
                $(this).attr('src', '').attr('src', src);
            });
        }

        function hideAndShowNext(oldItem, newItem) {
            var oldItem = oldItem,
                newItem = newItem,
                goToNext = 1;

            if (options.paging === 1) paging.inProgress = 1;
            if (options.magazine == 'blesk') {
                scrollToLeaderboard(newItem);
            }
            if (newItem != 'error') {
                pauseVideosInItem(oldItem);

                $that.find('ul.listed li.active').removeClass('active');
                oldItem.fadeOut(options.fadeOut, () => {
                    oldItem.removeClass('active');
                    buttonsControl(newItem);
                    newItem
                        .addClass('active')
                        .hide()
                        .fadeIn(options.fadeIn, () => {
                            if (options.paging === 1) {
                                paging.inProgress = 0;
                                applyPagingStyle(
                                    calculateActivePagingStyle(
                                        chapterIds.indexOf(newItem.data('id')),
                                    ),
                                );
                            }

                            hashControl(newItem.data('id'));
                        });
                });
                if (options.paging === 1) {
                    $('.paging a.active').removeClass('active');

                    paging.pagingDiv.find(`a[data-id="${newItem.data('id')}"]`).addClass('active');
                    notMakeActive = 1;
                    controlPagingElements();
                }
            }

            // nastavit hodnoty GA pro listovani
            const pagePath = location.pathname + window.location.search;
            const pageTitle = document.title;
            dataLayer.push({ event: 'ga.pageview', pagePath, pageTitle });

            // obnovit reklamu
            if (typeof window.__cncAdsReload !== 'undefined') {
                window.__cncAdsQueue = window.__cncAdsQueue || [];
                window.__cncAdsQueue.push(() => {
                    window.__cncAdsReload();
                });
            }

            // Marfeel | PV - vypnutí trackování pro listování v článku
            window.marfeel = window.marfeel || { cmd: [] };
            window.marfeel.cmd.push([
                'compass',
                function (compass) {
                    compass.trackNewPage();
                },
            ]);
        }

        // Nastaví/odstraní href + aria-disabled/disabled na dané sadě prev/next elementů
        // (sdílené pro .listingControlButtons i .paging - obě mají stejnou sémantiku sousední kapitoly)
        // Href se skládá z pořadového čísla kapitoly, ne z ID
        function updatePrevNextHref($prevEl, $nextEl, currentIndex, itemId) {
            const withoutRelatedArticles =
                currentIndex == chapterIds.length - 2 && options.showRecentArticles == false;

            const isOnIntro = !itemId || itemId === 'intro';

            let prevPosition;
            if (isOnIntro) {
                prevPosition = null;
            } else if (currentIndex > 0) {
                prevPosition = currentIndex - 1;
            } else {
                prevPosition = 0;
            }

            const nextPosition =
                currentIndex + 1 < chapterIds.length &&
                !withoutRelatedArticles &&
                !String(chapterIds[currentIndex + 1]).includes('disabled')
                    ? currentIndex + 1
                    : null;

            if (prevPosition !== null) {
                $prevEl
                    .attr('href', chapterUrl(prevPosition))
                    .removeAttr('aria-disabled')
                    .removeClass('disabled');
            } else {
                $prevEl.removeAttr('href').attr('aria-disabled', 'true').addClass('disabled');
            }

            if (nextPosition !== null) {
                $nextEl
                    .attr('href', chapterUrl(nextPosition))
                    .removeAttr('aria-disabled')
                    .removeClass('disabled');
            } else {
                $nextEl.removeAttr('href').attr('aria-disabled', 'true').addClass('disabled');
            }
        }

        function buttonsControl(newItem) {
            var buttons = $that.find('.listingControlButtons'),
                newItem = newItem,
                itemId = newItem.data('id'),
                currentIndex = chapterIds.indexOf(itemId);
            const isNotLastChapterNotOnBlesk =
                    currentIndex != -1 &&
                    currentIndex + 1 < chapterIds.length &&
                    options.magazine !== 'blesk',
                isNotLastChapterOnBlesk =
                    currentIndex != -1 &&
                    currentIndex < chapterIds.length - 1 &&
                    options.magazine == 'blesk',
                withoutRelatedArticles =
                    currentIndex == chapterIds.length - 2 && options.showRecentArticles == false;

            updatePrevNextHref(
                buttons.find('.prev'),
                buttons.find('.next:not(.moreArticles)'),
                currentIndex,
                itemId,
            );
            updatePrevNextHref(
                $that.find('.paging .prev'),
                $that.find('.paging .next'),
                currentIndex,
                itemId,
            );

            if (!itemId || itemId == 'intro') {
                buttons.find('.prev, .next, .counter, .showStart').hide();
                buttons.find('.moreArticles').hide();
                $that.find('.authors').show();

                if (settings.paging == 1) {
                    const nextBtn = $that.find('.paging .next');
                    if (!nextBtn.hasClass('showNext')) nextBtn.addClass('showNext');
                    $that.find('.paging .showPrev').removeClass('showPrev');
                }
                // harakiri-hack: hiding social buttons
                if (options.magazine == 'blesk') {
                    /* PUVODNI_BLESK_VERZE-$that.find(".authors").show();
                  buttons.find("button.startListing").show();
                  $that.find(".smallControlButtons").show();
                  $that.find(".bottom .socialShares").hide();
                  $that.find(".articleDetails .socialShares").show(); */
                }

                // odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('.startListing').hide();
                    buttons.find('.next').show();
                    buttons.find('span.next').hide();
                    $('.bottom').css('margin-left', '-139px');
                    $('.articleContent > h1')
                        .unbind('click', showIntro)
                        .unbind('mouseover')
                        .click((e) => {
                            e.preventDefault();
                        });
                }
            } /* PUVODNI_BLESK_VERZE-else if ((currentIndex == chapterIds.length -2) && options.magazine == "blesk" && options.showRecentArticles == true) { //předposlední pouze blesk
                var related = $that.find("ul.listed li#related").length;

                buttons.find("buttton, .counter").hide();
                if(related === 1) {
                    buttons.find("button.moreArticles, button.prev, button.next:not(.moreArticles)").show();
                    buttons.find("button.next:not(.moreArticles)").hide();
                }
                else {
                    buttons.find("button.prev, button.next:not(.moreArticles), .counter").show();
                }
            } */ else if (
                currentIndex + 1 == chapterIds.length ||
                withoutRelatedArticles ||
                String(chapterIds[currentIndex + 1]).includes('disabled')
            ) {
                buttons.find('.next, .startListing').hide();
                buttons.find('.showStart').show();
                buttons.find('.prev').removeClass('showStart');
                buttons.find('.moreArticles').hide();

                if (settings.paging == 1) {
                    const prevBtn = $that.find('.paging .prev');
                    if (!prevBtn.hasClass('showPrev')) prevBtn.addClass('showPrev');
                    $that.find('.paging .showNext').removeClass('showNext');
                }

                // odlisne chovani blesk
                if (options.magazine == 'blesk') {
                    /* PUVODNI_BLESK_VERZEbuttons.find("button.prev").hide();
					 $that.find(".smallControlButtons").hide();
					 $that.find(".authors").hide();
					 buttons.find("buttton, .counter").hide();
					 $that.find(".socialShares").hide(); */
                }

                // odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('.next').before('<span class="next" />');
                    buttons.find('.showStart').hide();
                    $('.bottom').removeAttr('style');
                }
            } /* PUVODNI_BLESK_VERZE-else if (currentIndex == 0 && options.magazine == "blesk") {
                $that.find(".listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart").hide();
                $that.find('.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles"), .listingControlButtons .counter').show();
                if (options.magazine == "blesk") {
                    $that.find(".bottom .socialShares").css("margin-left", 0).show();
                    $that.find(".bottom .authors").hide();

                }
            } else if (currentIndex == 1 && options.magazine == "blesk") {
                $that.find(".listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart").hide();

                $that.find('.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles")').show();


            } */ else if (isNotLastChapterNotOnBlesk || isNotLastChapterOnBlesk) {
                buttons.find('.showStart, .startListing').hide();
                buttons.find('.prev, .next, .counter').show();
                buttons.find('.moreArticles').hide();

                if (options.magazine == 'blesk') {
                    $that.find('.bottom .socialShares').css('margin-left', 0).show();
                    // $that.find(".bottom .authors").hide();
                }

                if (currentIndex === 0) {
                    buttons.find('.showPrev').addClass('showStart');
                    buttons.find('.moreArticles').hide();
                } else if (currentIndex > 0) {
                    buttons.find('.showPrev').removeClass('showStart');
                }

                if (options.paging == 1) {
                    const next = $that.find('.paging .next'),
                        prev = $that.find('.paging .prev');

                    if (next.hasClass('showNext') == false) next.addClass('showNext');
                    if (prev.hasClass('showPrev') == false) prev.addClass('showPrev');
                }

                // harakiri-hack: showing social buttons, hiding authors
                if (options.magazine == 'blesk') {
                    $that.find('.bottom .socialShares').css('margin-left', 0).show();
                    // $that.find(".bottom .authors").hide();
                }

                // odlisne chovani BPZ
                if (options.magazine == 'bpz') {
                    buttons.find('span.prev, span.next').hide();
                    buttons.find('.startListing').hide();

                    buttons.find('.next, .counter').show();
                    $('.bottom').removeAttr('style');
                    $('.articleContent > h1').mouseover(function (e) {
                        e.stopImmediatePropagation();
                        $(this)
                            .css({
                                color: '#FF0036',
                                'text-decoration': 'underline',
                                cursor: 'pointer',
                            })
                            .mouseleave(function () {
                                $(this).removeAttr('style');
                            })
                            .bind('click', showIntro);
                    });
                }
            } else {
                console.log('nothing');
            }

            if (options.magazine == 'bpz' && currentIndex == 0) {
                $that.find('.smallControlButtons .showPrev').removeClass('showStart').show();
            }

            counterControl(currentIndex + 1);
        }

        function counterControl(position) {
            var position = position;
            if (
                position > 0 &&
                chapterIds.indexOf(position) <= chapterIds.length &&
                options.paging == 0
            ) {
                $that.find('.counter .actualNumber').html(position);
            }
        }

        // Do URL jde pořadové číslo kapitoly, úvod je bez parametru
        function hashControl(id) {
            const position = chapterIds.indexOf(id);
            if (position > 0) {
                window.history.pushState(null, null, chapterUrl(position));
            } else {
                history.pushState('', document.title, chapterUrl(0));
            }
        }

        // function hashControl(id) {
        //     var id = id;
        //     if (id && id != "intro") {
        //         window.history.pushState(null, null, "#" + id);
        //     }
        //     else {
        //         history.pushState("", document.title, window.location.pathname + window.location.search);
        //     }
        // }

        function controlPagingElements() {
            const section = getSection();
            if (section && paging.inProgress === 0 && notMakeActive != 1) {
                // Odkaz se hledá podle pořadového čísla (data-pos), ne podle ID.
                // Bereme resolvedPosition, protože section může nést starou podobu URL.
                $that.find(`.paging a[data-pos="${resolvedPosition}"]`).addClass('active');
            }

            let activeAnchor = $that.find('.paging a.active');
            if (options.paging === 1) paging.pagingDiv = $that.find('.paging');

            // if no active paging anchor, make the "intro" one active!
            if (paging.inProgress === 0) {
                if (!activeAnchor.length) {
                    activeAnchor = $that.find('.paging a[data-id="intro"]').addClass('active');
                }
            }
            controlPagingButtons(activeAnchor);
            if (options.paging === 1) paging.inProgress = 0;
        }

        function controlPagingButtons(activeAnchor) {
            var { pagingDiv } = paging,
                { pagingBy } = options,
                showPagingSystem,
                activeAnchor = activeAnchor.data('id'),
                activeAnchorIndexOfChapters = chapterIds.indexOf(activeAnchor);
            // set showPagingSystem - threeDots
            if (chapterIds.length <= pagingBy || chapterIds.length <= 12) {
                paging.showPagingSystem = false;
            } else {
                paging.showPagingSystem = true;
            }
            // hashControl(activeAnchor);
            if (paging.showPagingSystem == true) {
                threeDots = $('<span class="threeDots" style="cursor: default;">...</span>');
                $that.find('.pagingHolder').addClass('centered');
                if (paging.pagingDiv.find('.threeDots.next').length <= 0) {
                    paging.pagingDiv.find('.pagingHolder a:first-child').before(
                        threeDots
                            .clone()
                            .addClass('prev')
                            .attr('data-moveto', 'prev')
                            .bind('click', (e) => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                    paging.pagingDiv.find('.pagingHolder a:last-of-type').after(
                        threeDots
                            .clone()
                            .addClass('next')
                            .attr('data-moveto', 'next')
                            .bind('click', (e) => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                }

                paging.pagingDiv.find('.threeDots.next').hide();
                paging.pagingDiv.find('.threeDots.prev').hide();
                applyPagingStyle(calculateActivePagingStyle(activeAnchorIndexOfChapters));
            }
        }

        function calculateActivePagingStyle(activeAnchorIndexOfChapters) {
            // output as "fromStart"/"almostStart"/"between"/"almostEnd"/"toEnd"
            let style,
                { pagingBy } = options,
                activeIndex = activeAnchorIndexOfChapters;
            if (activeIndex == pagingBy - 1) {
                style = 'almostStart';
            } else if (activeIndex <= pagingBy - 2) {
                style = 'fromStart';
            } else if (chapterIds.length - pagingBy == activeIndex) {
                style = 'almostEnd';
            } else if (chapterIds.length - pagingBy <= activeIndex) {
                style = 'toEnd';
            } else {
                style = 'between';
            }
            return style;
        }

        function applyPagingStyle(style) {
            var style = style;
            if (settings.paging === 1) pagingDiv = paging.pagingDiv;
            if (paging.showPagingSystem == true) {
                switch (style) {
                    case 'fromStart':
                        pagingDiv.find('.pagingHolder a').hide();
                        for (i = 0; i <= options.pagingBy - 1; i++) {
                            pagingDiv.find(`a[data-id="${chapterIds[i]}"]`).show();
                        }
                        pagingDiv.find('.threeDots.next').show();
                        pagingDiv.find('.threeDots.prev').hide();
                        break;
                    case 'almostStart':
                        pagingDiv.find('.pagingHolder a').hide();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv.find(`a[data-id="${chapterIds[i + 1]}"]`).show();
                        }
                        pagingDiv.find('.threeDots.next').show();
                        pagingDiv.find('.threeDots.prev').show();
                        break;
                    case 'between':
                        pagingDiv.find('.pagingHolder a').hide();
                        var active = pagingDiv.find('a.active'),
                            offset = Math.floor(options.pagingBy / 2),
                            activeId = active.data('id');
                        if (offset % 2 != 0) offset -= 1;
                        active.show();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv
                                .find(
                                    `a[data-id="${
                                        chapterIds[chapterIds.indexOf(activeId) + i - offset - 1]
                                    }"]`,
                                )
                                .show();
                        }
                        pagingDiv.find('.threeDots.next').show();
                        pagingDiv.find('.threeDots.prev').show();
                        break;
                    case 'almostEnd':
                        pagingDiv.find('.pagingHolder a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find(`a[data-id="${chapterIds[i - 2]}"]`).show();
                        }

                        pagingDiv.find('.threeDots.prev').show();
                        pagingDiv.find('.threeDots.next').show();
                        break;
                    case 'toEnd':
                        pagingDiv.find('.pagingHolder a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find(`a[data-id="${chapterIds[i]}"]`).show();
                        }
                        pagingDiv.find('.threeDots.next').hide();
                        pagingDiv.find('.threeDots.prev').show();
                        break;
                }
                centerPaging();
            }
        }
        function switchPaging(element) {
            (moveto = element.data('moveto')), (paging.inProgress = 1);
            paging.moveto = moveto;
            paging.lastVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):last').data('id'),
            );
            paging.firstVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):first').data('id'),
            );
            paging.pagingDiv.find('.pagingHolder a').hide();
            switch (moveto) {
                case 'next':
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                `a[data-id="${
                                    chapterIds[paging.lastVisibleAnchorIndexOfChapters + i]
                                }"]`,
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:last').data('id')) <
                        chapterIds.length - 1
                    ) {
                        paging.pagingDiv.find('.threeDots.next').show();
                    }

                    paging.pagingDiv.find('.threeDots.prev').show();
                    break;
                case 'prev':
                    paging.pagingDiv.find('.pagingHolder a').hide();
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                `a[data-id="${
                                    chapterIds[paging.firstVisibleAnchorIndexOfChapters - i]
                                }"]`,
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:first').data('id')) > 0
                    ) {
                        paging.pagingDiv.find('.threeDots.prev').show();
                    }

                    paging.pagingDiv.find('.threeDots.next').show();
                    break;
            }
            paging.firstVisibleAnchorIndexOfChapters = null;
            paging.lastVisibleAnchorIndexOfChapters = null;
        }
        // BPZ
        function showIntro() {
            $('articleContent > h1').removeAttr('style').css({
                color: 'black',
                'text-decoration': 'none',
                cursor: 'normal',
            });
            $('articleContent > h1').removeAttr('style').unbind('mouseover');
            const oldItem = $('ul.listed > li.active'),
                newItem = $('ul.listed > li:first-child');
            hideAndShowNext(oldItem, newItem);
        }
        function centerPaging() {
            let anchorsWidth, pagingDivWidth, buttonsWidth;
            $that
                .find('.pagingHolder:first-of-type a')
                .filter("[style='display: block']")
                .each(function () {
                    anchorsWidth += $(this).width();
                });
        }

        function scrollToLeaderboard(newItem) {
            $(window).scrollTop(0);
            if ($(newItem).attr('data-id') == 'intro') {
                $that.find('h1').removeClass('visually-hidden');
            } else {
                $that.find('h1').addClass('visually-hidden');
            }
        }

        return this;
    };
})(jQuery);
